<template>
  <div style="min-width: 1300px;">
  	
  	<div :style="{'width':'100%','height':hideSplit?'70px':'74px'}">
  		<div style="width:100%;height:70px;position:fixed;top:0;padding: 0 15%;background-color: white;z-index: 10000;">
  			<div class="logo"  @click="goHome" >
					<div style="float: left;margin-left: 10px;padding-top: 15px;">
						<h2>专 利 管 理 运 营 平 台</h2>
						<span style="font-size: 12px;-webkit-transform:scale(0.3) !important;">Patent management and operation platform</span>
					</div>
				</div>
				<div class="nav-list">
					<span id="header-title-gide">
						<span v-for="(item,i) in dataList" :key="i">
							<span class="nav-list-title" @click="openUrl(item.url)">{{item.title}}</span>
							<span v-if="i != dataList.length-1"> | </span>
						</span>
					</span>
					
					
				</div>
				
  		</div>
  		<div class="split" v-if="!hideSplit" ></div>
  	</div>	
  	
  </div>
</template>

<script>
	import {headerData} from '@/view/data/header.js'
export default {
  name: 'index',
  data:function(){
  	return {
  		dataList:headerData
  	}
  },
	components: {},
	props: ["hideSplit"],
	methods:{
			goHome:function(){
				 this.$router.push({path: '/v2'});
			},
		openUrl:function(url){
			window.open(url);
		}
	}
}
</script>

<style scoped>
	.container-padding{
		padding: 0 8%;
	}
	
	.logo {
		width: 320px;
		height: 50px;
		float: left;
		position: relative;
		cursor: pointer;
	}
	
	.nav-list {
		width: 420px;
		margin: 0 auto;
		position: absolute;
		right: 15%;
		bottom: 15px;
		text-align: right;
	}
	
	.nav-list-title {
		font-size: 12px;
		cursor: pointer;
	}
	
	.split{
		background: linear-gradient(#8D8D8D, #ADADAD);
		height: 4px;
		width:100%;position:fixed;top:70px;padding: 0 15%;background-color: white;z-index: 10000;
	}
</style>



// WEBPACK FOOTER //
// src/view/v2/layout/head.vue